// 매장 등록 모달(시안 #mStore) — 스토라넷에 없는 매장만 직접 등록한다(source 는 서버가 manual).
import { useEffect, useRef, useState } from "react";
import { createStore, errorText } from "./api";
import { showToast } from "../../../utill/utill";
import { useDismiss } from "../../v6common/a11y";

const digits = (s) => String(s || "").replace(/\D/g, "");
const bizInput = (v) => {
    const d = digits(v).slice(0, 10);
    if (d.length > 5) return `${d.slice(0, 3)}-${d.slice(3, 5)}-${d.slice(5)}`;
    if (d.length > 3) return `${d.slice(0, 3)}-${d.slice(3)}`;
    return d;
};

export default function StoreModal({ onClose, onSaved }) {
    const [f, setF] = useState({ name: "", biz: "", ceo: "", phone: "", tel: "", addr: "" });
    const [err, setErr] = useState("");
    const [saving, setSaving] = useState(false);
    const dismiss = useDismiss(onClose);
    const first = useRef(null);
    useEffect(() => { first.current && first.current.focus(); }, []);
    const set = (k) => (e) => setF((o) => ({ ...o, [k]: k === "biz" ? bizInput(e.target.value) : e.target.value }));

    async function save() {
        const name = f.name.trim();
        const biz = digits(f.biz);
        if (!name) { setErr("상호명을 입력해 주세요."); return; }
        if (biz && biz.length !== 10) { setErr("사업자번호는 10자리입니다."); return; }
        setSaving(true);
        try {
            // 같은 번호는 서버가 409 duplicate_business_number 로 막는다 — 그 message 를 보인다
            const opt = (v) => v.trim() || null;
            await createStore({ business_name: name, business_number: biz || null, owner_name: opt(f.ceo), phone: opt(f.phone), store_phone: opt(f.tel), address: opt(f.addr) });
            showToast(`${name} 매장을 등록했습니다.`, "success");
            onSaved();
        } catch (e) {
            setErr(errorText(e));
            setSaving(false);
        }
    }

    const fld = (label, k, ph, extra = {}) => (
        <div className="fld"><label>{label}</label><input className="inp" placeholder={ph} value={f[k]} onChange={set(k)} {...extra} /></div>
    );
    return (
        <div className="modal on" {...dismiss}>
            <div className="mbox" style={{ width: 560 }}>
                <div className="mh"><h3>매장 등록</h3><span style={{ color: "var(--tx3)", fontSize: 12.5 }}>스토라넷에 없는 매장만 직접 등록합니다</span><button className="btn btn-ghost btn-sm x" onClick={onClose} title="닫기"><i className="fa-solid fa-xmark"></i></button></div>
                <div className="mb">
                    <div className="grid2" style={{ marginBottom: 12 }}>
                        <div className="fld"><label>상호명 <span className="req">*</span></label><input ref={first} className="inp" placeholder="상호명을 입력하세요" value={f.name} onChange={set("name")} /></div>
                        {fld("사업자번호", "biz", "000-00-00000", { inputMode: "numeric" })}
                    </div>
                    <div className="grid2" style={{ marginBottom: 12 }}>
                        {fld("대표자명", "ceo", "대표자명을 입력하세요")}
                        {fld("휴대폰", "phone", "010-0000-0000")}
                    </div>
                    <div className="grid2" style={{ marginBottom: 12 }}>
                        {fld("매장연락처", "tel", "매장 연락처를 입력하세요")}
                        {fld("주소", "addr", "주소를 입력하세요")}
                    </div>
                    <div className="note">대표자 휴대폰 뒤 4자리가 사장님 앱 초기 비밀번호가 됩니다. 휴대폰이 없으면 임시 비밀번호 대상으로 표시됩니다.</div>
                    <div className={`err${err ? " on" : ""}`}>{err}</div>
                </div>
                <div className="mf">
                    <button className="btn" onClick={onClose}>취소</button>
                    <button className="btn btn-pri" onClick={save} disabled={saving}><i className="fa-solid fa-check"></i>등록</button>
                </div>
            </div>
        </div>
    );
}
